import React from 'react';
import type { SVGProps } from './types';

const HomeIcon = (props: SVGProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinecap="square"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M10 14.165h.008"
      />
      <path
        stroke="currentColor"
        strokeWidth="1.2"
        d="M16.667 7.082v10.833H3.334V7.082"
      />
      <path
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M18.333 8.749L9.999 2.082 1.666 8.749"
      />
    </svg>
  );
};

export { HomeIcon };
